// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"938":"26261d37","1137":"26261d37","3086":"26261d37","3629":"26261d37","4036":"26261d37","4795":"26261d37","8435":"26261d37","8781":"26261d37"}[chunkId] + ".chunk.css";
};